var React = require('react');

function File (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"currentColor","d":"M9.062 4.993a.312.312 0 0 1-.312-.312V.001H.625A.625.625 0 0 0 0 .623v16.227c0 .345.28.625.625.625h13.75c.345 0 .625-.28.625-.625V4.993H9.062Z","key":0}),React.createElement("path",{"fill":"currentColor","d":"M10 0c.08 0 .156.017.23.046.028.012.051.031.078.047.033.019.07.032.098.058l4.2 3.594H10V0Z","key":1})]);
}

File.defaultProps = {"fill":"none","viewBox":"0 0 15 18"};

module.exports = File;

File.default = File;
